let isInitPopoverConfirmInit = false;

window.initPopoverConfirm = function () {
    const myDefaultWhiteList = $.fn.tooltip.Constructor.Default.whiteList;
    // To allow button elements
    myDefaultWhiteList.button = ['type', 'name', 'value', 'form'];

    if (!isInitPopoverConfirmInit) {
        $('.btn-popover-confirm').each(function (key, item) {
            let element = $(item);
            const formTarget = element.data('linked-form');
            element.popover({
                html: true,
                content: `
                    <button  ${formTarget ? "form=" + formTarget : ""} type="submit" name="confirmation"
                        value="1" class="btn btn-danger">Valider</button>
                    <button ${formTarget ? "form=" +formTarget : ""} type="button" 
                        class="btn btn-success">Annuler</button>`,
                placement: element.data('placement') || 'top',
                trigger: 'focus',
                container: element.data('container') || 'body',
                boundary: 'window',
                title: element.prop('title') || 'Confirmation'
            });

        })
    }
    isInitPopoverConfirmInit = true;
}
